import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractApiErrorMessage } from '../../shared/utils/extract-api-error-message.util';
import { AdminCreateOrderRequestDTO } from '../types/dtos/admin-create-order.dto';
import { Order } from '../types/order.type';
import { ADMIN_ORDER_API_PATHS } from '../constants/orders-api-paths.constant';

type UseAdminCreateOrderResult = {
  isCreating: boolean;
  createOrder: (payload: AdminCreateOrderRequestDTO) => Promise<Order | null>;
};

export function useAdminCreateOrder(): UseAdminCreateOrderResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isCreating, setIsCreating] = useState(false);

  const createOrder = async (payload: AdminCreateOrderRequestDTO): Promise<Order | null> => {
    setIsCreating(true);

    try {
      const created = await HttpClient.post<Order>(ADMIN_ORDER_API_PATHS.CREATE, payload);
      enqueueSnackbar('Commande créée avec succès', { variant: 'success' });
      return created;
    } catch (error) {
      enqueueSnackbar(
        extractApiErrorMessage(error, 'Une erreur est survenue lors de la création de la commande'),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsCreating(false);
    }
  };

  return { isCreating, createOrder };
}
